import { makeObservable, observable } from 'mobx'

class RetailerExceedsProductLimitStore {
  @observable managePlanStore
  @observable plan

  constructor (managePlanStore, plan) {
    makeObservable(this)
    this.managePlanStore = managePlanStore
    this.plan = plan
  }
}

export default RetailerExceedsProductLimitStore
